import { combineReducers } from 'redux';

import {
  SET_DOCUMENT_TITLE,
  SET_META_TAGS,
} from '../types';

// State interfaces
interface MetaTag {
  name?: string;
  property?: string;
  content: string;
  [key: string]: any;
}

interface SeoState {
  metaTags: MetaTag[];
  title: string;
}

// Action interfaces
interface SetDocumentTitleAction {
  type: typeof SET_DOCUMENT_TITLE;
  payload: string;
}

interface SetMetaTagsAction {
  type: typeof SET_META_TAGS;
  payload: MetaTag[];
}

type TitleAction = SetDocumentTitleAction | { type: string };
type MetaTagsAction = SetMetaTagsAction | { type: string };

const INITIAL_STATE = {
  META_TAGS: [] as MetaTag[],
  TITLE: 'PTT Brain',
};

const title = (state: string = INITIAL_STATE.TITLE, action: TitleAction): string => {
  if (action.type === SET_DOCUMENT_TITLE) {
    return (action as SetDocumentTitleAction).payload;
  }
  return state;
};

const metaTags = (state: MetaTag[] = INITIAL_STATE.META_TAGS, action: MetaTagsAction): MetaTag[] => {
  if (action.type === SET_META_TAGS) {
    return (action as SetMetaTagsAction).payload;
  }
  return state;
};

export default combineReducers<SeoState>({
  metaTags,
  title,
});